import { ReactNode } from "react";
import { OrderFlowLogo } from "@/components/OrderFlowLogo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { LanguageToggle } from "@/components/LanguageToggle";
import PWAInstallButton from "../navigation/InstallationBtn";

interface LandingNavProps {
  /** Right-side actions (buttons, links, etc.) */
  actions?: ReactNode;
}

/**
 * Reusable navigation bar for public-facing pages (Landing, Register, etc.)
 * Maintains consistent "Blade Runner Ambient" design with slim utility bar style.
 */
export function LandingNav({ actions }: LandingNavProps) {
  return (
    <nav 
      className="sticky top-0 z-50 bg-gradient-to-r from-[hsl(var(--gradient-start))] to-[hsl(var(--gradient-end))] px-4 sm:px-6 py-2 border-b border-white/10" 
      aria-label="Main navigation"
    >
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <OrderFlowLogo
          size="small"
          showText={true}
          animated={true}
          onGradientBackground={true}
          to="/"
        />
        
        {/* Actions - Right Side */}
        <div className="flex items-center gap-1 sm:gap-2">
          <PWAInstallButton/>
          <ThemeToggle onGradientBackground={true} />
          <LanguageToggle onGradientBackground={true} />
          {actions}
        </div>
      </div>
    </nav>
  );
}
